module.exports = __webpack_public_path__ + "static/media/be.c2d80701.svg";